import { render } from "./gauge.vue?vue&type=template&id=3b5b3fb9&scoped=true"
import script from "./gauge.vue?vue&type=script&lang=js"
export * from "./gauge.vue?vue&type=script&lang=js"

import "./gauge.vue?vue&type=style&index=0&id=3b5b3fb9&scoped=true&lang=less"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b5b3fb9"]])

export default __exports__